const A = "/brand";

export function WhyNow() {
  return (
    <section
      data-testid="why-now-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #FAFAF8 0%, #EFF5F4 50%, #F8F7F5 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-12 md:pt-20 pb-10 md:pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 items-center">

          {/* LEFT: image */}
          <div className="lg:col-span-6 -mx-6 md:-mx-10 lg:mx-0 reveal order-2 lg:order-1">
            <div className="relative overflow-hidden" style={{ aspectRatio: "3/4" }}>
              <div
                className="absolute inset-x-0 top-0 h-24 z-[1]"
                style={{ background: "linear-gradient(to bottom, #FAFAF8 0%, transparent 100%)" }}
              />
              <div
                className="absolute inset-y-0 right-0 w-32 lg:w-48 z-[1]"
                style={{ background: "linear-gradient(to left, #EFF5F4 0%, transparent 100%)" }}
              />
              <img
                src={`${A}/blueprint4joy-speaking-audience-engagement.jpg`}
                alt="Lara standing between round tables facilitating a discussion."
                loading="lazy"
                className="w-full h-full object-cover"
                style={{ objectPosition: "50% 0%" }}
              />
              <div
                className="absolute inset-x-0 bottom-0 h-32 z-[1]"
                style={{ background: "linear-gradient(to top, #F8F7F5 0%, transparent 100%)" }}
              />
            </div>
          </div>

          {/* RIGHT: copy */}
          <div className="lg:col-span-6 lg:pl-14 pb-12 lg:pb-0 reveal order-1 lg:order-2">
            <p className="text-[11px] tracking-[0.28em] uppercase text-[#F6A041] mb-6 font-medium">
              Why This Matters Now
            </p>
            <div className="space-y-5">
              <p className="text-xl text-[#57534E] leading-relaxed">
                Right now, organizations are navigating rapid change, AI disruption, burnout, and quiet disengagement.
              </p>
              <p className="text-xl text-[#57534E] leading-relaxed">Trying harder isn't the answer.</p>
              <p className="font-display text-4xl md:text-5xl text-[#159E9A] leading-tight py-1">
                Clarity is.
              </p>
              <p className="text-xl text-[#57534E] leading-relaxed">
                When people understand their real capacity and design around it, performance improves because alignment improves.
              </p>
              <p className="text-xl text-[#57534E] leading-relaxed">This isn't motivation.</p>
              <p className="font-display text-3xl md:text-4xl text-[#1C1917] leading-snug">
                It's sustainable momentum.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}